<script>
/**
 * API组件的配置格式：
 * {
 *      component: 'api',
 *      uuid: '',
 *      label: '',
 *      output: '',
 *      deps: [],
 *      props: {
 *          method: 'GET' / 'POST' ...
 *          url: 'a/b/c/{d}'        // 请求地址（已支持路径参数，参数值从payload及全局参数中读取替换）
 *          payloadSources: [       // 取值组件的uuid
 *              'uuid_0',
 *              'uuid_1'
 *          ],
 *          config: {}, // axios的config参数
 *          pickKey: 'data.a',   // 从返回值中取哪个键的值
 *          preProcessCode: '', // 发送前处理代码
 *          postProcessCode: '' // 发送后处理代码
 *      }
 * }
 *
 * 使用时机：
 * ### 在dep配置中
 *   - 组件A被api组件依赖，同时组件B依赖api组件的change事件
 *   - A触发事件时执行api，结果保存在api的output值中（全局数据），并抛出change事件
 *   - B的依赖处理被调用，可以取得api的结果
 *
 * ### 在需要远端校验时
 *   - C组件的props.validator值为api组件的id
 *   - 在校验时将自动调用api，走全局的请求错误管理
 *   - 这项操作同样会触发api更新当前值并抛出change事件
 *
 */
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { $http } from '../component-base/xhr';
import { component } from './props';
import { composeUrlWithParam, getValueByPath } from '../../utils';
export default {
    name: component,
    extends: ComponentBase,
    data() {
        return {
            // eslint-disable-next-line no-undefined
            apiResult: undefined,
        };
    },
    methods: {
        // 保存调用结果
        saveResult(result) {
            this.apiResult = result;
            this.setSelfFormDataValue(result) && this.$emit('change');
        },
        async beforeSend(data) {
            return await this.send(data);
        },
        async send({ method, url, payload = {}, config = {} }) {
            let res;

            // eslint-disable-next-line no-unused-vars
            const _this = this;

            if (this.config.props.preProcessCode) {
                // eslint-disable-next-line
                eval(this.config.props.preProcessCode);
            }
            try {
                if (typeof this.formRoot.handleApiAction === 'function') {
                    // 有外部传入的请求方法
                    res = await this.formRoot.handleApiAction({
                        method,
                        url,
                        payload,
                        config,
                    });
                } else if (url) {
                    if (method === 'post') {
                        res = await $http.post(url, payload, config);
                    } else if (method === 'get') {
                        res = await $http.get(url, {
                            ...config,
                            params: payload,
                        });
                    } else {
                        // 一般不会用到这里，method目前只提供post/get
                        res = await $http({
                            ...config,
                            method,
                            data: payload,
                            url,
                        });
                    }
                }
            } catch (e) {
                // eslint-disable-next-line
                console.error(e);
                // eslint-disable-next-line no-undefined
                res = undefined;
            }

            if (this.config.props.postProcessCode) {
                // eslint-disable-next-line
                eval(this.config.props.postProcessCode);
            }

            // console.log(res);

            const data = this.config.props.pickKey
                ? getValueByPath(res, this.config.props.pickKey)
                : res;
            // console.log(data);
            const finalData = await this.afterSend(data);
            this.saveResult(finalData);
            return finalData;
        },
        async afterSend(data) {
            return data;
        },
        async trigger() {
            if (this.globalModel.isEdit) {
                return null;
            }
            const props = this.config.props;
            let payload = {};
            props.payloadSources.forEach(id => {
                payload = {
                    ...payload,
                    ...this.globalModel.getKeyValueById(id),
                };
            });

            let allPayload;
            if (this.props.omitGlobalParams) {
                allPayload = payload;
            } else {
                allPayload = this.globalModel.globalParams
                    ? {
                        // 有全局参数则附上全局参数
                        ...this.globalModel.globalParams,
                        ...payload,
                    }
                    : {
                        // 否则附上当前页面的params和query参数
                        ...this.$route.params,
                        ...this.$route.query,
                        ...payload,
                    };
            }

            return await this.beforeSend({
                method: props.method.toLowerCase(),
                url: composeUrlWithParam(props.url, allPayload),
                payload: allPayload,
                config: props.config,
            });
        },
        /**
         * 以下是组件公共方法的实现
         */
        // 覆盖公共依赖处理方法，api的依赖处理直接是发一次请求
        async depHandler() {
            await this.trigger();
        },
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            // API组件没有默认值
            if (!isEqual(this.apiResult, newValue)) {
                this.apiResult = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
            }
        },
    },
    render(h) {
        return h();
    },
};
</script>
